export default "__VITE_ASSET__Dw3i_T5D__"